var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:( _obj = {}, _obj[("footer-" + _vm.type)] = _vm.type, _obj[("footer-" + _vm.size)] = _vm.size, _obj ),attrs:{"data-background-color":_vm.backgroundColor}},[(_vm.$route.name !== 'ecommerce-page' && _vm.$route.name !== 'presentation')?void 0:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }